import { CBADGE_COLORS } from '../enums/cbadgeColors';
import i18n from '../plugins/i18n';

/**
 * @param {Boolean} status
 * @returns {String} CBADGE_COLORS
 */
export const getColorStatus = (status) => {
	switch (status) {
		case 'success': return CBADGE_COLORS.SUCCESS;
		case 'danger': return CBADGE_COLORS.DANGER;
		default: return CBADGE_COLORS.PRIMARY;
	}
};

/**
 * @param {Boolean} status
 * @returns {String} Text
 */
export const getTextStatus = (status) => {
	switch (status) {
		case 'success': return i18n.t('message.active');
		case 'danger': return i18n.t('message.inactive');
		default: return '';
	}
};
